import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin OH
 * @contact hjoh@detech.co.kr
 * @date 2024-08-20
 * @brief SEI 에너지솔루션 관리 개발
 *
 ********************************************************************/
import DataManagementFromProspectiveDocument from "@components/management/energySolution/electricVehicleChargerInstallationAnalysis/DataManagementFromProspectiveDocument";
import EnergySolutionManagementTree from "@components/management/energySolution/EnergySolutionManagementTree";
import CustomerRequestFacility from "@components/management/energySolution/highEfficiencyFacilityReplacementAnalysis/CustomerRequestFacility";
import HighEfficiencyFacilityList from "@components/management/energySolution/highEfficiencyFacilityReplacementAnalysis/HighEfficiencyFacilityList";
import MvdLevelManagement from "@components/management/energySolution/inverterEconomicAnalysis/MvdLevelManagement";
import MvdModelManagement from "@components/management/energySolution/inverterEconomicAnalysis/MvdModelManagement";
import { useState } from "react";
import { useOutletContext } from "react-router-dom";
export default function EnergySolutionManagementMain() {
    //props
    const { handleOpenPop } = useOutletContext();
    const treeItem = [
        {
            id: "high",
            name: "고효율 설비 교체 분석",
            smenu: [{ menuName: "고효율 설비 List" }, { menuName: "고객 요청 설비" }],
        },
        {
            id: "ev",
            name: "전기차 충전기 설치 분석",
            smenu: [{ menuName: "가견적서 데이터 관리" }],
        },
        {
            id: "inverter",
            name: "인버터 경제성 분석",
            smenu: [{ menuName: "MVD 모델 관리" }, { menuName: "전압 등급 관리" }],
        },
    ];
    const [treeSel, setTreeSel] = useState(treeItem[0]);
    const [menuSel, setMenuSel] = useState(0);
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "box-wrap" }, { children: [_jsx("div", Object.assign({ className: "box treebar pushy-menutype type2" }, { children: _jsx(EnergySolutionManagementTree, { treeItem: treeItem, treeSel: treeSel, setTreeSel: setTreeSel, menuSel: menuSel, setMenuSel: setMenuSel }) })), _jsx("div", Object.assign({ className: "content-wrap" }, { children: treeSel.id == "high" ? (_jsxs("div", Object.assign({ className: "l-divide" }, { children: [menuSel < 1 && _jsx(HighEfficiencyFacilityList, {}), menuSel > 0 && _jsx(CustomerRequestFacility, { handleOpenPop: handleOpenPop })] }))) : treeSel.id == "inverter" ? (_jsxs("div", Object.assign({ className: "l-divide" }, { children: [menuSel < 1 && _jsx(MvdModelManagement, {}), menuSel > 0 && _jsx(MvdLevelManagement, {})] }))) : (_jsx(DataManagementFromProspectiveDocument, { handleOpenPop: handleOpenPop })) }))] })) }));
}
